// extracted by mini-css-extract-plugin
module.exports = {"root":"_5d43b0"};